"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogWrapper = void 0;
// @ts-nocheck
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const EditComponentButton_1 = __importDefault(require("./EditComponentButton"));
const styles_1 = require("@material-ui/core/styles");
const Common_1 = require("../FormFields/Common");
const Delete_1 = __importDefault(require("@material-ui/icons/Delete"));
const DialogWrapper = props => {
    const classes = Common_1.useStyles();
    const { type, value, renderComponent, position, renderValue, renderHeader, readOnly, clearValue } = props;
    const dialogStyles = useDialogStyles(props);
    const [open, setOpen] = react_1.useState(false);
    const toggleModal = () => {
        setOpen(!open);
    };
    const isNotEmpty = Array.isArray(value) ? value.length > 0 : !!value;
    return (react_1.default.createElement("div", { className: classes.formElementWrapper },
        react_1.default.createElement(core_1.Dialog, { open: open, classes: { paper: dialogStyles.dialogPaper } }, renderComponent && renderComponent(toggleModal)),
        renderHeader && renderHeader(),
        position === 'top' && renderValue && renderValue(),
        react_1.default.createElement(EditComponentButton_1.default, { readOnly: !!readOnly, type: type, mode: value ? 'edit' : 'add', onClick: toggleModal }),
        isNotEmpty && (react_1.default.createElement(core_1.IconButton, { "aria-label": "clear", onClick: clearValue, disabled: readOnly },
            react_1.default.createElement(Delete_1.default, null))),
        position === 'bottom' && renderValue && renderValue()));
};
exports.DialogWrapper = DialogWrapper;
const useDialogStyles = styles_1.makeStyles((theme) => styles_1.createStyles({
    dialogPaper: (props) => ({
        top: '2vh',
        height: '96vh',
        maxHeight: '100%',
        width: '100vw',
        maxWidth: '100%',
        '@media (max-width: 650px)': {
            width: '100%',
            margin: 0,
        },
    }),
}));
exports.default = exports.DialogWrapper;
//# sourceMappingURL=DialogueWrapper.js.map